// extracted by mini-css-extract-plugin
export default {"container":"FeatureToggleBadge_container__PiG36","label":"FeatureToggleBadge_label__sk-B1","active":"FeatureToggleBadge_active__Pircb"};